<template>
    <div class="flex justify-center mt-8 px-4">
        <div class="w-full lg:w-3/4 xl:w-2/3">
            <div>
                <p class="text-lg leading-6 font-medium text-gray-900">
                    Complete your User Profile
                </p>
                <p class="mt-1 max-w-2xl text-sm leading-5 text-gray-500">
                    Now that your account is activated, let's finalize a few final settings!
                </p>
            </div>
            <form method="POST" :action="targetUrl">
                <input type="hidden" name="_method" value="put" />
                <input type="hidden" name="_token" :value="csrf" />
                <div class="pt-2">
                    <div class="">
                        <div class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start">
                            <label for="first_name"
                                   class="block text-sm font-medium leading-5 text-gray-700 sm:mt-px sm:pt-2">
                                First Name
                            </label>
                            <div class="mt-1 sm:mt-0 sm:col-span-2">
                                <div class="w-full max-w-xs rounded-md shadow-sm">
                                    <input type="text"
                                            id="first_name"
                                            name="first_name"
                                            v-model="user.first_name"
                                            class="block w-full text-sm leading-5"/>
                                </div>
                            </div>
                        </div>
                        <div class="mt-6 border-t border-gray-200 pt-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start">
                            <label for="last_name"
                                   class="block text-sm font-medium leading-5 text-gray-700 sm:mt-px sm:pt-2">
                                Last Name
                            </label>
                            <div class="mt-1 sm:mt-0 sm:col-span-2">
                                <div class="w-full max-w-xs rounded-md shadow-sm">
                                    <input type="text"
                                            id="last_name"
                                            name="last_name"
                                            v-model="user.last_name"
                                            class="block w-full text-sm leading-5"/>
                                </div>
                            </div>
                        </div>

                        <div class="mt-8 border-t border-gray-200 pt-8">
                            <div>
                                <p class="text-lg leading-6 font-medium text-gray-900">
                                    Notifications
                                </p>
                                <p class="mt-1 max-w-2xl text-sm leading-5 text-gray-500">
                                    Select here to enable your notifications for alarms.
                                </p>
                            </div>
                            <div class="mt-6">
                                <div class="border-t border-gray-200 pt-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start">
                                    <label
                                            class="block text-sm font-medium leading-5 text-gray-700 sm:mt-px sm:pt-2">
                                        Email Notifications?
                                    </label>
                                    <div class="mt-2 sm:mt-0 sm:col-span-2 flex items-center">
                                        <toggle name="email" class="flex" v-model:value="emailToggleBool"></toggle>
                                    </div>
                                </div>

                                <div v-if="emailToggleBool"
                                     class="mt-6 border-t border-gray-200 pt-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start">
                                    <label for="notification_email"
                                           class="block text-sm font-medium leading-5 text-gray-700 sm:mt-px sm:pt-2">
                                        Email for Notifications
                                    </label>
                                    <div class="mt-1 sm:mt-0 sm:col-span-2">
                                        <div class="w-full max-w-lg rounded-md shadow-sm">
                                            <input id="notification_email" type="email"
                                                   name="notification_email"
                                                   :value="user.email"
                                                   class="block w-full text-sm leading-5"/>
                                        </div>
                                    </div>
                                </div>

                                <div v-if="hasSmsEnabled"
                                  class="mt-6 border-t border-gray-200 pt-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start">
                                    <label
                                            class="block text-sm font-medium leading-5 text-gray-700 sm:mt-px sm:pt-2">
                                        SMS Notifications?
                                    </label>
                                    <div class="mt-2 sm:mt-0 sm:col-span-2 flex items-center">
                                        <toggle name="sms" class="flex" v-model:value="smsToggleBool"></toggle>
                                    </div>
                                </div>

                                <div v-if="smsToggleBool && hasSmsEnabled"
                                     class="mt-6 border-t border-gray-200 pt-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start">
                                    <label for="notification_sms"
                                           class="block text-sm font-medium leading-5 text-gray-700 sm:mt-px sm:pt-2">
                                        SMS Phone Number
                                    </label>
                                    <div class="mt-1 sm:mt-0 sm:col-span-2">
                                        <div class="w-full max-w-xs rounded-md shadow-sm">
                                            <input id="notification_sms"
                                                   name="notification_sms"
                                                   type="tel"
                                                   placeholder="555-303-5555"
                                                   class="block w-full text-sm leading-5"/>
                                        </div>
                                    </div>
                                </div>

                                <div v-if="hasVoiceEnabled"
                                  class="mt-6 border-t border-gray-200 pt-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start">
                                    <label
                                           class="block text-sm font-medium leading-5 text-gray-700 sm:mt-px sm:pt-2">
                                        Voice Message Notifications?
                                    </label>
                                    <div class="mt-2 sm:mt-0 sm:col-span-2 flex items-center">
                                        <toggle name="voice" class="flex" v-model:value="voiceToggleBool"></toggle>
                                    </div>
                                </div>

                                <div v-if="voiceToggleBool && hasVoiceEnabled"
                                     class="mt-6 border-t border-gray-200 pt-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start">
                                    <label for="notification_voice"
                                           class="block text-sm font-medium leading-5 text-gray-700 sm:mt-px sm:pt-2">
                                        Voice Message Phone Number
                                    </label>
                                    <div class="mt-1 sm:mt-0 sm:col-span-2">
                                        <div class="w-full max-w-xs rounded-md shadow-sm">
                                            <input id="notification_voice" type="tel"
                                                   name="notification_voice"
                                                   placeholder="555-303-5555"
                                                   class="block w-full text-sm leading-5"/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="mt-6 border-t border-gray-200 pt-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start">
                            <div class="hidden sm:block col-span-1"></div>
                            <div class="flex justify-center sm:col-span-2">
                                <button type="submit"
                                        class="w-full sm:w-auto relative items-center px-4 py-2 border border-transparent text-sm text-center leading-5 font-medium rounded-md text-white bg-green-600 hover:bg-green-400 focus:outline-none focus:ring-green-200 focus:border-green-400 active:bg-green-400">
                                    Save Settings
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
    import Toggle from "@/components/elements/toggle";
    import {SonicuCoreMixin} from "@/mixins/SonicuCoreMixin";


    export default {
        name: "userEdit",
        mixins: [SonicuCoreMixin],
        components: { Toggle},
        props: {
            user: Object,
            hasVoiceEnabled: Boolean,
            hasSmsEnabled: Boolean,
        },
        data() {
            return {
                smsToggleBool: false,
                voiceToggleBool: false,
                emailToggleBool: true,
            }
        },
        methods: {
        },
        computed: {
            targetUrl(){
                return this.company.buildCompanyRoute("users-info/"+this.user.id);
            },
        }
    }
</script>

<style scoped>

</style>